import React, { FunctionComponent } from "react"
import dayjs from "dayjs"
import ratmService from "../../utils/RATMService"
import templateManagementTableItems from "./TemplateManagementTableItems"
import PortalRoleTemplateWithLnksTypes from "../../types/portalTemplateTypes/PortalRoleTemplateWithLnksTypes"
import TemplateManagementTableContextMenu from "./TemplateManagementTableContextMenu/TemplateManagementTableContextMenu"
import "./TemplateManagementTable.css"

const TemplateManagementTableBody: FunctionComponent<{}> = () => {

    const { state, timeFormat } = ratmService
    const { roleTemplates, addOrEditTemplateId, deleteTemplateId } = state

    const handleMouseLeaveAndEnter = (index: number, isItInYet: boolean) => {
        let elem = document.getElementById(`6a3bac12eb364c1fa84e0fb2237c3ad7-${index}`)
        if (elem) {
            if (isItInYet) {
                elem.style.display = "flex"
            } else {
                elem.style.display = "none"
            }
        }
    }

    return (
        <tbody>
            {roleTemplates.map((prt: PortalRoleTemplateWithLnksTypes, i: number) =>
                <tr
                    key={i}
                    id={`d1aef1771456686fa88634df9e2c4-${i}`}
                    style={
                        {
                            backgroundColor:
                                `${(addOrEditTemplateId === prt.Template.RoleTemplateId && deleteTemplateId === -1) ?
                                    "#ffc10750" : (addOrEditTemplateId < 0 && deleteTemplateId === prt.Template.RoleTemplateId) ?
                                        "#dc354550" :
                                        "unset"}`
                        }}
                    onMouseEnter={() => handleMouseLeaveAndEnter(i, true)}
                    onMouseLeave={() => handleMouseLeaveAndEnter(i, false)}
                >
                    {templateManagementTableItems.map((item, j) =>
                        <td
                            key={j}
                            style={{ maxWidth: item.maxWidth }}
                        >
                            <div className={`TemplateManagementTableBodyTdItem ${j === templateManagementTableItems.length - 1 ? "TemplateManagementTableBodyTdItemLast" : "TemplateManagementTableBodyTdItemNotLast"}`}>
                                <div className="TemplateManagementTableBodyTdItemRightInfo">
                                    <p style={{ fontWeight: item.fw }}>
                                        {/*@ts-ignore*/}
                                        {!item.isCheckBox && (item.isDate ? dayjs(prt.Template[item.key]).format(timeFormat) : prt.Template[item.key])}
                                    </p>
                                    {/*@ts-ignore*/}
                                    {item.isCheckBox && <div className={`f7d0c564b742b1b08d7cf22ea65b02 ${prt.Template[item.key] ? "f7d0c564b742b1b08d7cf22ea65b02Yes" : "f7d0c564b742b1b08d7cf22ea65b02No"}`}>
                                        {/*@ts-ignore*/}
                                        <span className="material-icons">{`${prt.Template[item.key] ? "done" : "close"}`}</span>
                                    </div>}
                                </div>
                                {j === templateManagementTableItems.length - 1 &&
                                    <div className="TemplateManagementTableBodyTdItemContextMenuWrapper">
                                        <TemplateManagementTableContextMenu index={i} RoleTemplateId={prt.Template.RoleTemplateId} />
                                    </div>
                                }
                            </div>
                        </td>
                    )}
                </tr>
            )}
        </tbody>
    )
}

export default TemplateManagementTableBody

